<template>
    <div>
        
        <b-container fluid>
           


            <b-row class="mt-4 px-3">
                <b-col>
                    <h5 class="pt-3">Underload At 8PM  {{ dateOn }}</h5>
                   
                    
                </b-col>
                <b-col>
                    <b-form inline>
                    <label class="mr-sm-2" for="inline-form-custom-select-pref">Date At:</label>
                   
                    <b-form-datepicker
                      v-model="datefrom"
                      class="mr-sm-2"
                      size="sm"
                      :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                    ></b-form-datepicker>
                                  
                  <b-button @click="fetchDailyunderload()" size="sm" >Show</b-button>
                </b-form>
                </b-col>
                <b-col class="text-right"> 
                <!--  <b-button variant="dark" pill @click="downloadcsv()">Export</b-button> <b-button variant="dark" pill @click="downloadcsv()">Export</b-button> -->
                  <b-button variant="dark" pill size="sm" class="mr-2"  @click="downloadPDF()">Download PDF</b-button>
                  <b-button variant="dark" pill size="sm"  @click="downloadcsv()">Download CSV</b-button>
                
                </b-col>
            </b-row>
            <b-row class="mt-4 px-3 mb-3">
                <b-col lg="6">
                    <label class="mr-2">Show</label>
                    <b-form-select v-model="perPage" id="perPageSelect" :options="pageOptions" size="sm" class="w-25">
                    </b-form-select>
                    <span class="ml-2">entries</span>

                   

                </b-col>
                <b-col lg="4" offset-md="2">
                    <b-form-group 
                    label="Filter" 
                    label-cols-sm="3" 
                    label-align-sm="right" 
                    label-size="sm" 
                    label-for="filterInput" 
                    class="mb-0"
                    >
                        <b-input-group size="sm">
                            <b-form-input v-model="filter" type="search" id="filterInput" placeholder="Type to Search">
                            </b-form-input>
                            <b-input-group-append>
                                <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row class="px-3">
                <b-col lg="12"> 

                    <b-table :style="tableHeight" id="my-uo-live" show-empty small sticky-header="true"  responsive striped outlined head-variant="dark"
                     caption-top hover borderless="borderless" stickyColumn="scrolled"
                        :items="records" 
                        :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :filterIncludedFields="filterOn" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered" class="scrollH d-flex">


                        <template v-slot:cell(imei_no)="row">
                            <b-link :href="'/device-data/'+row.value">{{row.value}}</b-link>
                        </template>
                        <template v-slot:cell(areacode)="row">
                            <span :id="'w-'+row.item.id" pill variant="success">{{row.value}}</span>
                            <b-popover
                                :target="`w-${row.item.id}`"
                                title="Ward"
                                triggers="hover focus">
                                {{row.item.ward_name}}													
                            </b-popover>
                        </template>
                        <template v-slot:cell(location)="row">
                            <span :id="'l-'+row.item.id" pill variant="success">{{row.value}}</span>
                            <b-popover
                                :target="`l-${row.item.id}`"
                                title="Location"
                                triggers="hover focus">
                                {{row.item.location}}													
                            </b-popover>
                        </template>
                        
                        


                        <template v-slot:cell(on_time)="row">
                            {{ row.value===null || row.value==='' ?'00:00':row.value }} 
                        </template>
                        <template v-slot:cell(off_time)="row">
                            {{ row.value===null || row.value==='' ?'00:00':row.value }} 
                        </template>
                        <template v-slot:cell(actions)="row">
                        <b-button
                        pill  
                        variant="primary" 
                        class="mr-1 icon-btn"  
                        @click="editSchedule(row.item.imei_no, row.item.on_time,row.item.off_time,row.item.group_id,row.item.supervisor_id,)" size="sm"><b-icon icon="pencil" font-scale="1" 
                        ></b-icon></b-button>
                    <!-- <b-button pill variant="success" class="mr-1" size="sm" ><b-icon icon="power" @click="sendCommand('ON', row.item.imei_no)"></b-icon> ON</b-button>							
                    <b-button pill variant="danger" class="mr-1" size="sm" ><b-icon icon="power" @click="sendCommand('OFF', row.item.imei_no)"></b-icon> OFF</b-button> -->

                    </template>
                </b-table>
                </b-col>
                </b-row>
                <b-row class="px-3 mb-3">
                    <b-col lg="6">
                        <span class="mr-2">Showing {{(currentPage-1)*perPage}} to {{currentPage*perPage}} of {{records.length}} entries</span>
                    </b-col>
                    <b-col lg="6">
                        <b-pagination v-model="currentPage" pills :total-rows="totalRows" :per-page="perPage" align="right" size="sm" prev-text="Prev" next-text="Next" first-number last-number></b-pagination>
                    </b-col>
                </b-row>
            
        </b-container>
      
    </div>
</template>

<script>
export default {
  name: 'underload_report_at_8pm',
  props: {
    msg: String,   
    tableHeight:String,
  },
  mounted(){
    this.getreportUO();
   // console.log('mounted ======================================');
  },
  data() {
		var self = this;
		
		return{
			loading: false, 
            reporthUrl: self.$session.get('apiurl')+'bareillyapi/get_underload_overload',
            search_status: 0,
            dateOn:'',
            datefrom:'',
            records: [],            
			filteredrecords: [],
			device: {},
			fields: [
				/* { key: 'imei_no', label: 'IMEI Number', sortable: true,}, */
				{ key: 'feeder_pillar_no', label: 'F.No.', sortable: true,},
                { key: 'areacode', label: 'Ward', sortable: true,},	
				{ key: 'location', label: 'Location',  class: 'text-left',
					formatter: (value) => { 
						if(value != null){
							if(value.length > 30){
								return value.substring(0,30)+"...";
							}
							
						}
						return value;
					},
				},                
                { key: 'no_of_fittings', label: 'Fittings', sortable: true,},
				{ key: 'light_on', label: 'Light ON', sortable: true,},
				{ key: 'light_off', label: 'Light OFF', sortable: true,}				
				/* { key: 'actions', label: 'Alert', 'extra':1 }, */
			],
			totalRows: 1,
			currentPage: 1,
			pageOptions: [10, 20, 50, 100],
			perPage: 10,
			sortBy: '',
			sortDesc: false,
			sortDirection: 'asc',
			filter: null,
			filterOn: [],
        }
    },
    methods: {
        getreportUO(){
            var self = this;
           
                //self.loading = true;
                self.search_status = 0;

                self.axios.post(self.reporthUrl, {
                    accesskey: self.$session.get('access_key'),
                    datefrom: self.datefrom
                })
                .then(function (response) {
                   // self.loading = false;
                    if(response.data.error == 0){
                        self.records = response.data.result.reports;                       
                       // self.filteredrecords = response.data.result.reports;
                        var dateOnReport = response.data.result.dateOn; 
                        self.dateOn = self.$moment(dateOnReport).format('DD-MM-YYYY');                        
                       // self.loading 	= false;
                        self.totalRows 	= self.records.length;
						
                        /* var msg = 'Search Completed!';
                        self.$bvToast.toast(msg, {
                            title: 'Delete',
                            toaster: 'b-toaster-bottom-right',
                            autoHideDelay: 5000,
                            variant: 'warning',
                            solid: true,
                            appendToast: true
                        }); */
                    }else{
                        self.search_status = 0;
                    }
                })
                .catch(function (error) {
                    alert(error);
                });
            
            
        },onFiltered(filteredItems) {
			this.totalRows = filteredItems.length
			this.currentPage = 1
			
		},
        downloadcsv() {
      var self = this;
      var header = new Array();
      self.fields.forEach(function(item) {
        if (!item.extra) {
          header.push(item.label);
        }
      });

      //var d = table.rows().data();
      var finalarr = new Array();
      finalarr.push(header);
      self.records.forEach(function(row) {
        var dataarr = new Array();
        self.fields.forEach(function(field) {
          if (field.key != "extra") {
            var value = row[field.key];

            if(field.key === 'location'){
                if(value == ''){
                    value ='';	
                }else{
                    if(value != null){
                        value = value.replaceAll(","," ");
                    }else{
                        value ='';
                    }                    
                }
            }
            dataarr.push(value);
          }
        });
        finalarr.push(dataarr);
      });

      let csvContent = "data:text/csv;charset=utf-8," + finalarr.map((e) => e.join(",")).join("\n");

      var encodedUri = encodeURI(csvContent);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", "daily_8PM_underload_report.csv");
      document.body.appendChild(link); // Required for FF

      link.click();
    },    
    downloadPDF(){
			var self = this;

			var pdfMake = require('pdfmake/build/pdfmake.js');
			var pdfFonts = require('pdfmake/build/vfs_fonts.js');
			pdfMake.vfs = pdfFonts.pdfMake.vfs;

			var pdfdata = new Array();
			var data = new Array();
			var headerlength = 0;
			
			self.fields.forEach(element => {				
				data.push(element.label);
				headerlength++;
			});
			var count = headerlength;
			
			pdfdata.push(data);
			for(var i=0; i<self.records.length; i++){
				data = new Array();

				/* var output_status = self.records[i]['output_status'];
				var amp_r = self.records[i]['amp_r'];
				var amp_y = self.records[i]['amp_y'];
				var amp_b = self.records[i]['amp_b'];
				var kw_r = self.records[i]['kw_r']; */
				self.fields.forEach(element => {
					var value = self.records[i][element.key];

					
					/* if(element.key == 'total_kw'){
							value = (value/1).toFixed(3);
						} */


                if(element.key === 'location'){
                    if(value == ''){
                        value ='';	
                    }else{

                    if(value != null){
                        value = value.replaceAll(","," ");
                    }else{
                        value ='';
                    }
                    
                    }
                }
						




					data.push(value);
				});
				pdfdata.push(data);
			}
			//var deviceid = ''
			

			var d = new Date();
			var uniq = d.getFullYear()+'-'+d.getMonth()+'-'+d.getDate()+'-'+d.getTime();
			var fontsize = 14;
			var page = "landscape";
			var pagesize = "A4";
			if (count < 10) {
				fontsize = 14;
				 page = "portrait";
				pagesize = "A4";
			} else if (count < 15) {
				 fontsize = 10;
				page = "portrait";
				 pagesize = "A4";
			} else if (count > 15) {
				 fontsize = 14;
				page = "landscape";
				pagesize = "A3";
			}
			var docDefinition = {
				content: [
					{ text: 'Underload At 8PM : '+self.dateOn, style: 'heading' },                    
					{
						layout: 'lightHorizontalLines',
						table: {
							headerRows: 1,

							body: pdfdata
						}
					}
				],
				styles: {
					heading: {
						fontSize: 20,
						alignment: 'center',
						lineHeight: 1,
						bold: true
					},
                    subheading: {
                        fontSize: 14,
						alignment: 'center',
						lineHeight: 2,
						bold: false
                    }
				},
				defaultStyle: {
					fontSize: fontsize,
					bold: false
				},
				//pageOrientation: 'landscape',
				pageSize: pagesize,
       			pageOrientation: page
			};
			pdfMake.createPdf(docDefinition).download("daily_8PM_underload_report_"+uniq+".pdf");
		},
        fetchDailyunderload(){
            var datefrom = this.datefrom;
            if(datefrom!=''){
                this.loading = true;
                this.getreportUO();
            }
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

.footer{
  font-size: 10px;
}

#my-uo-live .thead-dark th {
    color: #fff;
	background-color: #FF9A37;
    border-color: #FF9A37;
}
#my-uo-live .first-col {
   border-radius: 20px 0px 0px 0px;
   min-width: 130px;
}
#my-uo-live .last-cal {
   border-radius: 0px 20px 0px 0px;
   min-width: 153px;
}
</style>
